export class Game {
  // display_name: String;
  // alias: String;
  // connected: Boolean;

  constructor(data = {}) {
    this.display_name = data.display_name || '';
    this.alias = data.alias || '';
    this.connected = data.connected || false;
  }
}
